"use strict";

exports.__esModule = true;

function scroll(currentY, targetY) {
  var needScrollTop = targetY - currentY;
  var _currentY = currentY;
  setTimeout(function () {
    var dist = Math.ceil(needScrollTop / 10);
    _currentY += dist;
    window.scrollTo(_currentY, currentY);
    if (needScrollTop > 10 || needScrollTop < -10) {
      scroll(_currentY, targetY);
    } else {
      window.scrollTo(_currentY, targetY);
    }
  }, 1);
}
exports["default"] = scroll;


//////////////////
// WEBPACK FOOTER
// ./src/bsjyy/js/util/scroll.js
// module id = 47
// module chunks = 7 8